import { render, staticRenderFns } from "./ComradeWorkloadAndSalary.vue?vue&type=template&id=6b4ed661&scoped=true"
import script from "./ComradeWorkloadAndSalary.vue?vue&type=script&lang=js"
export * from "./ComradeWorkloadAndSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4ed661",
  null
  
)

export default component.exports